import reactAttributesList from './react-attributes.json';

/**
 * List of valid HTML element attributes.
 *
 * @type {Array}
 * @see  {@link https://reactjs.org/docs/dom-elements.html}
 * @see  {@link https://github.com/jackyho112/react-html-attributes}
 */
export const VALID_ATTRIBUTES_LIST = reactAttributesList;
